var render = function render(){
  var _vm$dashboard, _vm$dashboard2, _vm$dashboard$info$ca, _vm$dashboard3, _vm$dashboard3$info, _vm$dashboard$info$me, _vm$dashboard4, _vm$dashboard4$info, _vm$dashboard$info$fo, _vm$dashboard5, _vm$dashboard5$info, _vm$dashboard$info$pa, _vm$dashboard6, _vm$dashboard6$info, _vm$dashboard$info$pa2, _vm$dashboard7, _vm$dashboard7$info, _vm$dataPizza;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.dashboard ? _c('div', [_c('StatusFormacao', {
    attrs: {
      "status-list": (_vm$dashboard = _vm.dashboard) === null || _vm$dashboard === void 0 ? void 0 : _vm$dashboard.statusFormacao,
      "data-hora-info": (_vm$dashboard2 = _vm.dashboard) === null || _vm$dashboard2 === void 0 ? void 0 : _vm$dashboard2.dataHoraInfo
    },
    on: {
      "visualizar-listagem": function ($event) {
        return _vm.openDialogListarStatusFormacao(null);
      }
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Carga Horária Ofertada")]), _c('div', {
    staticClass: "display-1 font-weight-bold mb-9"
  }, [_vm._v(_vm._s((_vm$dashboard$info$ca = (_vm$dashboard3 = _vm.dashboard) === null || _vm$dashboard3 === void 0 ? void 0 : (_vm$dashboard3$info = _vm$dashboard3.info) === null || _vm$dashboard3$info === void 0 ? void 0 : _vm$dashboard3$info.cargaHorariaOfertada) !== null && _vm$dashboard$info$ca !== void 0 ? _vm$dashboard$info$ca : 0))])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Média De Avaliação")]), _c('div', {
    staticClass: "display-1 font-weight-bold mb-9"
  }, [_vm._v(_vm._s((_vm$dashboard$info$me = (_vm$dashboard4 = _vm.dashboard) === null || _vm$dashboard4 === void 0 ? void 0 : (_vm$dashboard4$info = _vm$dashboard4.info) === null || _vm$dashboard4$info === void 0 ? void 0 : _vm$dashboard4$info.mediaAvaliacao) !== null && _vm$dashboard$info$me !== void 0 ? _vm$dashboard$info$me : 0) + "%")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Formações Realizadas")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboard$info$fo = (_vm$dashboard5 = _vm.dashboard) === null || _vm$dashboard5 === void 0 ? void 0 : (_vm$dashboard5$info = _vm$dashboard5.info) === null || _vm$dashboard5$info === void 0 ? void 0 : _vm$dashboard5$info.formacoesRealizadas) !== null && _vm$dashboard$info$fo !== void 0 ? _vm$dashboard$info$fo : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-checkbox-marked-outline")])], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": _vm.openDialogListarFormacoes
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Participantes")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboard$info$pa = (_vm$dashboard6 = _vm.dashboard) === null || _vm$dashboard6 === void 0 ? void 0 : (_vm$dashboard6$info = _vm$dashboard6.info) === null || _vm$dashboard6$info === void 0 ? void 0 : _vm$dashboard6$info.participantes) !== null && _vm$dashboard$info$pa !== void 0 ? _vm$dashboard$info$pa : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "blue"
    }
  }, [_vm._v("mdi-account-group-outline")])], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": _vm.openDialogListarParticipantes
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Participação")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboard$info$pa2 = (_vm$dashboard7 = _vm.dashboard) === null || _vm$dashboard7 === void 0 ? void 0 : (_vm$dashboard7$info = _vm$dashboard7.info) === null || _vm$dashboard7$info === void 0 ? void 0 : _vm$dashboard7$info.participacao) !== null && _vm$dashboard$info$pa2 !== void 0 ? _vm$dashboard$info$pa2 : 0) + " %")]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-chart-pie")])], 1)])], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "fill-height",
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "mb-4 text-start"
  }, [_vm._v("Formações")]), ((_vm$dataPizza = _vm.dataPizza) === null || _vm$dataPizza === void 0 ? void 0 : _vm$dataPizza.labels.length) > 0 ? _c('PieChart', {
    attrs: {
      "chartData": _vm.dataPizza
    }
  }) : _c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Não há dados!")])], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.stackedChartData ? _c('HorizontalBarStackedChart', {
    attrs: {
      "rawData": _vm.stackedChartData,
      "height": _vm.stackedChartHeight
    }
  }) : _c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Não há dados!")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.exportarDadosPdf
    }
  }, [_vm._v(" Exportar Gráficos ")])], 1)], 1), _vm.dialogListarFormacaoStatus.visible ? _c('ListarFormacaoPorStatusDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacaoStatus.visible,
      "content": _vm.dialogListarFormacaoStatus.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacaoStatus.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarFormacoes.visible ? _c('ListarFormacoesDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacoes.visible,
      "content": _vm.dialogListarFormacoes.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacoes.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarParticipantes.visible ? _c('ListarParticipantesDialog', {
    attrs: {
      "visible": _vm.dialogListarParticipantes.visible,
      "content": _vm.dialogListarParticipantes.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarParticipantes.close();
      }
    }
  }) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }